import React from "react";

//Importar dependencias del react-router-dom.
import { NavLink } from "react-router-dom";

//Importar imágenes (logos).
import logoLPSoftfrom from "../../../assets/images/logo-lpsoft.png";

//Importar íconos de Material UI.
import { Chat, ForwardToInbox, Group, Settings, Logout } from '@mui/icons-material/';

// Sidebar: Componenete que renderiza la barra lateral de navegacion entre paginas y permisos

const Sidebar = ({ permisos }) => {

    //Ajustar el tamaño de lo íconos del sidebar.
    const iconSize = 30

    return (
        <div className="container-sidebar__layout"  >

            {/*---------Contenedor de los íconos del sidebar--------------*/}
            <div className="container-sidebar__icons" >
                {permisos.chats && <NavLink to='Chats'
                    className={({ isActive }) => `content-sidebar__icon ${isActive ? "active" : ""}`}
                >
                    <div className="content-sidebar__icon--container">
                        <Chat sx={{ fontSize: `${iconSize}px` }} />
                    </div>
                    <span className="content-sidebar__text">Chats</span>
                </NavLink>}

                {permisos.usuarios && <NavLink to='Usuarios'
                    className="content-sidebar__icon">
                    <div className="content-sidebar__icon--container">
                        <Group sx={{ fontSize: `${iconSize}px` }} />
                    </div>
                    <span className="content-sidebar__text">Usuarios</span>
                </NavLink>}

                {permisos.remates && <NavLink to='Remates' className="content-sidebar__icon">
                    <div className="content-sidebar__icon--container">
                        <ForwardToInbox sx={{ fontSize: `${iconSize}px` }} />
                    </div>
                    <span className="content-sidebar__text">Remates</span>
                </NavLink>}

                {permisos.config && <NavLink to='Configuracion' className="content-sidebar__icon">
                    <div className="content-sidebar__icon--container">
                        <Settings sx={{ fontSize: `${iconSize}px` }} />
                    </div>
                    <span className="content-sidebar__text">Configuración</span>
                </NavLink>}

            </div>

            {/*---------Contenedor del logo LPSoft--------------*/}
            <div className="container-sidebar__lpsoft">
                <label>Desarrollado por</label>
                <img alt="LPSoft" src={logoLPSoftfrom} className="logo-small" />
            </div>

            {/*---------Contenedor de Cerrar Sesión--------------*/}
            {<NavLink to='Logout' className="content-sidebar__icon logout">
                <div className="content-sidebar__icon--container" >
                    <Logout sx={{ fontSize: `${iconSize}px` }} />
                </div>
                <span className="content-sidebar__text logout">Salir </span>
            </NavLink>}

        </div>
    )
};

export default Sidebar;